import React, { useEffect, useState } from 'react';
import EventsFilter from './eventsFilter';

import PageTitle from '../../../components/PageTitle';
import Swal from 'sweetalert2';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as FeatherIcon from 'react-feather';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Input, Row, Button } from 'reactstrap';

import PreloaderWidget from '../../../components/Loader';
import {
    delete_advertisement,
    delete_publications,
    list_Advertisement,
    new_Advertisement,
    update_advertisement,
} from '../../../helpers/actions/api.functions';
import FilterButton from '../../../components/FilterButton';
import AddEvents from './addAdvertisement';

const AdvertisementList = () => {
    const [data, setData] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [editData, setEditData] = useState({});
    const [modal, setModal] = useState(false);
    const [modalb, setModalb] = useState(false);
    const [edit, setEdit] = useState(false);
    const [key, updateKey] = useState(0);

    const [stateActive, setStateActive] = useState('true');

    const getStatus = () => {
        return (
            <>
                {stateActive === 'true' ? (
                    <FeatherIcon.Eye
                        className="icon-action delete-ico"
                        onClick={() => {
                            setStateActive('false');
                            updateKey(key + 1);
                        }}
                    />
                ) : (
                    <FeatherIcon.EyeOff
                        className="icon-action delete-ico"
                        onClick={() => {
                            setStateActive('true');
                            updateKey(key + 1);
                        }}
                    />
                )}
            </>
        );
    };

    console.log(stateActive);

    const getCareers = () => {
        setIsActive(true);
        list_Advertisement()
            .then((res) => {
                setIsActive(false);
                setData(res.data);
                console.log(res);
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response.message);
            });
    };
    const openedit = (row) => {
        setEdit(true);
        setEditData({
            id: row?.id,
            description: row?.description,
            title: row?.title,
            link: row?.link,
            status: row?.status,
            image: row?.image,
            file: row?.file,
        });

        setModalb(true);
    };

    const defaultSorted = [
        {
            dataField: 'id',
            order: 'desc',
        },
    ];

    const toggle = () => {
        setModal(false);
    };
    const toggleb = () => {
        setModalb(false);

        setEdit(false);
        setEditData({});
    };

    const newCareers = (formdata) => {
        setIsActive(true);
        let payload = new FormData();

        Object.entries(formdata).forEach(([key, value]) => {
            if (key !== 'id' && value !== undefined && value !== null) {
                if (edit && (key === 'file' || key === 'image')) {
                    if (value instanceof File) {
                        payload.append(key, value);
                    }
                } else {
                    payload.append(key, value);
                }
            }
        });

        if (edit) {
            update_advertisement(formdata.id, payload)
                .then((res) => {
                    setIsActive(false);
                    toast.success(res.message);
                    getCareers();
                    setModalb(false);
                    setEditData({});
                    setEdit(false);
                })
                .catch((err) => {
                    setIsActive(false);
                    toast.error(err.response?.message || 'Update failed');
                });
        } else {
            new_Advertisement(payload)
                .then((res) => {
                    setIsActive(false);
                    toast.success(res.message);
                    getCareers();
                    setModalb(false);
                    setEditData({});
                    setEdit(false);
                })
                .catch((err) => {
                    setIsActive(false);
                    toast.error(err.response?.message || 'Creation failed');
                });
        }
    };

    const handleDelete = (d) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                delete_advertisement(d)
                    .then((res) => {
                        setIsActive(false);
                        toast.success(res.message);
                        getCareers();
                        console.log(res);
                        setModalb(false);
                        setEditData({});
                        setEdit(false);
                    })
                    .catch((err) => {
                        setIsActive(false);
                        toast.error(err.response.message);
                    });
            }
        });
    };
    const columns = [
        {
            dataField: 'title',
            text: 'Title',
            sort: true,
        },
        {
            dataField: 'description',
            text: 'Description',
            sort: true,
            formatter: (cell) => {
                const cleanHTML = cell?.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '');

                return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
            },
        },
        {
            dataField: 'link',
            text: 'Link',
            sort: true,
        },

        {
            dataField: 'status',
            text: 'Status',
            sort: true,
            formatter: (rowContent) => {
                return (
                    <div
                        className={`badge ${
                            rowContent === 'active'
                                ? 'badge-soft-success'
                                : rowContent === 'inactive'
                                ? 'badge-soft-danger'
                                : ''
                        }`}>
                        {rowContent}
                    </div>
                );
            },
        },

        {
            dataField: 'id',
            text: 'Action',
            sort: false,
            formatter: (rowContent, row) => {
                return (
                    <div className="d-flex">
                        <div onClick={() => openedit(row)}>
                            <FeatherIcon.Edit3 className="icon-action view-ico mx-2" />
                        </div>
                        <div onClick={() => handleDelete(rowContent)}>
                            <FeatherIcon.Trash className="icon-action view-ico mx-2" />
                        </div>
                    </div>
                );
            },
        },
    ];

    const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
        <React.Fragment>
            <label className="d-inline mr-1">Show</label>
            <Input
                type="select"
                name="select"
                id="no-entries"
                className="custom-select custom-select-sm d-inline col-1 pl-1"
                defaultValue={currSizePerPage}
                onChange={(e) => onSizePerPageChange(e.target.value)}>
                {options.map((option, idx) => {
                    return (
                        <option key={idx} value={option.page}>
                            {option.text}
                        </option>
                    );
                })}
            </Input>
            <label className="d-inline ml-1">entries</label>
        </React.Fragment>
    );
    const { SearchBar } = Search;

    useEffect(() => {
        getCareers();
    }, []);
    if (isActive) {
        return <PreloaderWidget />;
    }
    return (
        <React.Fragment>
            <Row className="page-title">
                <Col md={12}>
                    <PageTitle
                        breadCrumbItems={[{ label: 'Advertisement', path: '/advertisement-list', active: true }]}
                        title={'Advertisement'}
                    />
                </Col>
            </Row>
            <Row>
                <Card className="w-100">
                    <CardBody>
                        <ToolkitProvider
                            bootstrap4
                            keyField="id"
                            data={data}
                            columns={columns}
                            search
                            exportCSV={{ onlyExportFiltered: true, exportAll: false }}>
                            {(props) => (
                                <React.Fragment>
                                    <Row className="mb-2">
                                        <Col className="text-left">
                                            <FilterButton
                                                onClick={() => {
                                                    console.log('fb');
                                                    setModalb(!modalb);
                                                }}
                                                btnname="Add Advertisement"
                                                className="filterbtn ml-0"
                                            />
                                        </Col>
                                    </Row>

                                    <BootstrapTable
                                        {...props.baseProps}
                                        bordered={true}
                                        defaultSorted={defaultSorted}
                                        pagination={paginationFactory({
                                            sizePerPage: 5,
                                            sizePerPageRenderer: sizePerPageRenderer,
                                            sizePerPageList: [
                                                { text: '5', value: 5 },
                                                { text: '10', value: 10 },
                                                { text: '25', value: 25 },
                                                { text: 'All', value: data?.length },
                                            ],
                                        })}
                                        wrapperClasses="table-responsive"
                                    />
                                </React.Fragment>
                            )}
                        </ToolkitProvider>
                    </CardBody>
                </Card>
            </Row>
            {/* /////////////////////////////////////////////////// */}
            {modal && <EventsFilter open={modal} handleClose={toggle} handleApply={toggle} />}
            {modalb && (
                <AddEvents open={modalb} handleClose={toggleb} handleApply={newCareers} data={editData} edit={edit} />
            )}
        </React.Fragment>
    );
};

export default AdvertisementList;
